export const Shrines00HallName = "Shrines00Hall";
export const Shrine01HelloWorldName = "Shrine01HelloWorld";
export const Shrine02VariablesName = "Shrine02Variables";
export const Shrine03ConditionalsName = "Shrine03Conditionals";
export const Shrine03PingName = "Shrine03Ping";
